import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { Button } from "./components/ui/button";
import { logEnvConfig } from "./config/env";
import { initializeSentry, Sentry } from "./config/sentry";

// Log env config once at startup for deployment verification
logEnvConfig();

// Initialize Sentry FIRST
initializeSentry();

const rootElement = document.getElementById("root");
if (!rootElement) {
	throw new Error("Root element not found");
}
ReactDOM.createRoot(rootElement).render(
	<React.StrictMode>
		<Sentry.ErrorBoundary
			fallback={({ error, resetError }) => (
				<div style={{ padding: "20px", textAlign: "center" }}>
					<h2>Something went wrong</h2>
					<p>
						{error instanceof Error
							? error.message
							: "An unknown error occurred"}
					</p>
					<Button type="button" onClick={resetError}>
						Try again
					</Button>
				</div>
			)}
			showDialog
		>
			<App />
		</Sentry.ErrorBoundary>
	</React.StrictMode>,
);
